import 'react-dates/initialize';
import moment from 'moment';

import type { FunctionComponent } from 'react';
import 'moment/locale/es';
import { oneLine } from 'common-tags';

import 'react-dates/lib/css/_datepicker.css';
import dynamic from 'next/dynamic';

import styles from './Calendar.module.css';

import type { TypeCalendarProps } from './types';

const CalendarRange = dynamic(() => import('@/atoms/calendar-range'));
const CalendarSingle = dynamic(() => import('@/atoms/calendar-single'));

/**
 * Calendar
 */
export const Calendar: FunctionComponent<TypeCalendarProps> = ({
  variant,
  type,
  className,
  onChange,
  ...props
}: TypeCalendarProps) => {
  moment.locale('es');

  return (
    <div
      className={oneLine`
        ${styles['c-calendar']}
        ${styles[`c-calendar--${variant}`]}
        ${styles[`c-calendar--${type}`]}
        ${className}
      `}
    >
      {type === 'range' ? (
        <CalendarRange {...props} onChange={onChange} />
      ) : (
        <CalendarSingle {...props} onChange={onChange} />
      )}

      {variant === 'availability' && (
        <div className="text-body text-body--m mt-4 flex gap-4">
          <div className="flex items-center justify-center gap-2">
            <span className="inline-block h-4 w-4 rounded-full bg-primary-100" />{' '}
            Disponible
          </div>

          <div className="flex items-center justify-center gap-2">
            <span className="inline-block h-4 w-4 rounded-full bg-[#F8C7C4]" />{' '}
            Ocupado
          </div>
        </div>
      )}
    </div>
  );
};

Calendar.displayName = 'Calendar';
